module.exports = __webpack_public_path__ + "static/fv-media-mobile-a4b8f7c8441ba222198a16afb56e31f8.jpg";